import { useMutation, useQuery } from '@tanstack/react-query';
import axios, { type AxiosError } from 'axios';
import type { GenericErrorResponse } from '@/types/api.types';

export interface Affidavit {
  code: string;
  name: string;
  state: string;
  title: string;
}

export const useGetAffidavitsForWorkOrder = (workOrderId: string | undefined) => {
  return useQuery<Affidavit[]>({
    queryKey: ['affidavits', workOrderId],
    queryFn: async () => {
      if (!workOrderId) throw new Error('Work Order ID is required');
      const response = await axios.get<Affidavit[]>(`work-orders/affidavit/${workOrderId}`);
      return response.data;
    },
    enabled: !!workOrderId,
  });
};

export const useDownloadAffidavitPDF = () => {
  return useMutation<
    Blob,
    AxiosError<GenericErrorResponse>,
    {
      workOrderId: string;
      affidavitCode: string;
      blankTemplate?: boolean;
    }
  >({
    mutationFn: async ({ workOrderId, affidavitCode, blankTemplate }) => {
      const response = await axios.post<Blob>(
        `work-orders/affidavit/${workOrderId}/pdf`,
        {
          affidavitCode,
          blankTemplate,
        },
        {
          responseType: 'blob',
        }
      );
      return response.data;
    },
  });
};
